import { MemberPayload, VipMemberResponseType } from "types/member";

export const memberApi = {
  async getMemberVip(_username: string, _payload: MemberPayload) {
    return {
      status: 0,
      msg: "Success",
      data: {
        total_level: 10,
        current_level: 3,
        next_level: {
          level: 4,
          turnover: "100000",
          current_turnover: "65000",
          turnover_percentage: "65",
        },
        benefit: {
          birthday_bonus: "888",
          upgrade_reward: "1888",
        },
        rebate: {
          LC: "0.8%",
          SL: "1.2%",
          SB: "0.8%",
          FH: "1.0%",
          ES: "0.6%",
          BG: "0.8%",
          LT: "0.5%",
          KN: "0.5%",
          CF: "0.5%",
          OT: "0.5%",
        },
      },
    } as VipMemberResponseType;
  },
};
